const createURL = () => new URL("https://donamaid.com");

const removeEmptyFilters = filters => filters.filter(el => el.value != "");

const buildIncludes = includes =>
  url.searchParams.append("include", includes.toString());

const buildFilters = filters => {
  filters = removeEmptyFilters(filters);
  return filters.map(el =>
    url.searchParams.append(`filter[${el.name}]`, el.value)
  );
};

const buildSort = opts => {
  let fields = opts.fields.map((el, i) => (opts.desc[i] ? "-" : "") + el);
  return url.searchParams.append("sort", fields.toString());
};

const buildPagination = opts => {
  url.searchParams.append("page[number]", opts.number);
  return url.searchParams.append("page[size]", opts.size);
};

const buildQuery = querys => {
  return querys.map(item =>
    url.searchParams.append(`${item.name}`, item.value)
  );
};

let url = createURL();

const buildParams = opts => {
  if (opts.includes) buildIncludes(opts.includes);
  if (opts.filters) buildFilters(opts.filters);
  if (opts.sort) buildSort(opts.sort);
  if (opts.pagination) buildPagination(opts.pagination);
  if (opts.queries) buildQuery(opts.queries);

  let search = url.search;
  url = createURL();

  return search;
};

export default {
  buildParams
};



// WEBPACK FOOTER //
// ./src/api/helpers/params.js